<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>课程顾问跟进数据</Breadcrumb-item>
        <Breadcrumb-item>分配名单详情</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="16" :md="10" >
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生ID" >
            <Input name="uid"
                   v-model="queryParam.uid"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生姓名" :label-width="75">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.nickName"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="渠道" :label-width="75">
            <channel-select v-model="queryParam.regType" @on-change="search"></channel-select>
            <!-- <Select v-model.number="queryParam.canal" placeholder="全部"
                    clearable @on-change="search">
              <Option v-for="item in $constant.studentCanal"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select> -->
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索
          </Button>
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                  @click="exportData">导出
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/userList/getAssignDetails"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <div style="font-size: medium">
      官网:{{assignNum.pcNum}}
      移动:{{assignNum.mobileNum}}
      在线咨询:{{assignNum.onlineAskNum}}
      来电咨询:{{assignNum.telAskNum}}
      二维码转介绍:{{assignNum.qrNum}}
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        reload: 0,
        queryParam: {
          adviserId: '',
          uid: '',
          nickName: '',
          startTime: '',
          endTime: '',
          canal: '',
        },
        assignNum: '',
        title: [
          {
            title: '学生ID/姓名',
            key: 'uid',
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + '-' + row.nickName)
            }
          },
          {
            title: '电话',
            key: 'phoneNumber',
          },
          {
            title: '渠道',
            render: (h, params) => {
              let regType = params.regType
              let regTypesEnum = $constant.getEnum($constant.studentCanal, regType)
              console.log('regTypesEnum.text:' + regTypesEnum.text)
              return h('span', regTypesEnum && regTypesEnum.text)
            }
          },
        ]
      }
    },
    mounted: function () {
      let self = this
      this.$http.post('/userList/getAssignCanalDetails', self.queryParam).then(function (res) {
        self.assignNum = res.data
      })
    },
    created: function () {
      this.queryParam.adviserId = localStorage.adviserId
      this.queryParam.startTime = localStorage.startTime
      this.queryParam.endTime = localStorage.endTime
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      exportData () {
        this.exportLoading = true
        this.$http.get('/userList/exportAdviserAssignDetail', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '课顾分配名单详情.csv'
          link.click()
          this.exportLoading = false
        }).catch((e) => {
          this.exportLoading = false
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// ShowAssignDetail.vue?4e9d0fe8